<div class="message-container" [ngClass]="[type]">
  <div class="row-layout">
    <div class="message-content">
      <span class="message-icon">
        <hyperkit-icon
          [icon]="getIconClass()"
          size="large"
          [color]="type"
        ></hyperkit-icon>
      </span>
      <hyperkit-typography
        variant="body"
        size="md"
        color="primary"
        class="message-text"
        >{{ getText }}</hyperkit-typography
        >
      </div>
      <div class="message-actions">
        @if (getActionText) {
          <button class="action-button" (click)="onAction()">
            {{ getActionText }}
          </button>
        }
        @if (closable) {
          <button
            class="close-button"
            (click)="onClose()"
            aria-label="Close"
            >
            ✕
          </button>
        }
      </div>
    </div>
  </div>
